import {getStoreData, saveStoreData} from "../services/dataStorage.js";
import {PUBLIC_DATA_KEYS, TYPE_STORAGE} from "./enums.js";

const TABLE_CONFIG_NAME = 'tableConfig';
const TABLE_CONFIG_FILTER_NAME = 'tableConfigFilter';
const TABLE_CONFIG_FILTER_PERIOD_NAME = 'tableConfigFilterPeriod';

const DEFAULT_USER_KEY = 'default';

const getUserKey = () => {
    const loginName = getStoreData(TYPE_STORAGE.local, PUBLIC_DATA_KEYS.currentUserName, true);
    return loginName || DEFAULT_USER_KEY;
}

const readStore = (storeName) => {
    const storeJSON = getStoreData(TYPE_STORAGE.local, storeName, true);
    if (!storeJSON) {
        return {};
    }
    try {
        return JSON.parse(storeJSON) || {};
    } catch (e) {
        return {};
    }
}

const readUserData = (storeName, key) => {
    const store = readStore(storeName);
    return store[key]?.[getUserKey()] ?? null;
}

const writeUserData = (storeName, key, data, merge) => {
    const store = readStore(storeName);
    const userKey = getUserKey();
    const keyData = { ...store[key] };

    if (data) {
        keyData[userKey] = merge ? { ...keyData[userKey], ...data } : data;
    } else {
        delete keyData[userKey];
    }

    return saveStoreData(
        TYPE_STORAGE.local,
        storeName,
        true,
        JSON.stringify({
            ...store,
            [key]: keyData,
        }),
    );
}

export const getTableStoreData = (key) => readUserData(TABLE_CONFIG_NAME, key);

export const setTableStoreData = (key, data) => writeUserData(TABLE_CONFIG_NAME, key, data, true);

export const getTableFilterData = (key) => readUserData(TABLE_CONFIG_FILTER_NAME, key);

export const setTableFilterData = (key, data) => writeUserData(TABLE_CONFIG_FILTER_NAME, key, data);

export const getTableFilterPeriodData = (key) => readUserData(TABLE_CONFIG_FILTER_PERIOD_NAME, key);

export const setTableFilterPeriodData = (key, data) => writeUserData(TABLE_CONFIG_FILTER_PERIOD_NAME, key, data);
